import type { TOC } from '@ember/component/template-only';
import { concat, hash } from '@ember/helper';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketCustomReportingExploreController from 'lumen/controllers/market/custom-reporting/explore';

interface MarketCustomReportingExploreSignature {
  Args: {
    controller: MarketCustomReportingExploreController;
    model: unknown;
  };
}

<template>
  <div class="embed-container">
    <GeneralEmbeddedApp
      @baseURL={{@controller.ajax.host}}
      @id="looker-embed"
      {{! @glint-expect-error: Incorrect type }}
      @onMessage={{@controller.onMessage}}
      @query={{hash
        embed_domain=@controller.embedDomain
        market_id=@controller.hotelAndMarketService.market.id
        timezone=@controller.timezone
        user_type="custom_reporting"
      }}
      @url={{concat
        "/api/v3/custom-reporting/embed/explore/"
        @controller.model.modelName
        "/"
        @controller.model.exploreName
      }}
    />
  </div>
</template> satisfies TOC<MarketCustomReportingExploreSignature>;
